/**
 * Build-time feature flags (VITE_* env vars). A flag is off unless its var is
 * exactly the string "true".
 *
 * - VITE_ENABLE_AGENT_MD: agent-ready ".md" export (the download + copy
 *   agent-instructions controls in the results header).
 *   Off by default so the feature can ship dark until the backend agent-md route
 *   and the iris synthesizer changes are deployed everywhere.
 */
export const agentReadyMdEnabled = import.meta.env.VITE_ENABLE_AGENT_MD === 'true';
